function buildTooltipContentTankOverview($filter, metricDate, unitsAvailable){
    const dateString = $filter('date')(metricDate, 'MMMM d, yyyy');
    const unitsAvailableString = $filter('number')(unitsAvailable ) || 0;

    var tooltipString = `${dateString} <br> Available Units: ${unitsAvailableString}`;

    return tooltipString;
};

angular.module('angus.directives').directive('tankOverviewLineGraph', [
    '$filter', 'actionViewTemplates', '$window',
    function($filter, actionViewTemplates, $window) {
        return {
            scope: {
                data: '='
            },
            restrict: 'A',
            templateUrl: actionViewTemplates.tankOverviewLineGraph,
            link: function (scope, element, attr) {
                'use strict'

                let plotInstance = null;
                let currentSeries = [];
                let resizeWhileHidden = false;

                scope.$watch(function () {
                    return scope.data;
                }, function () {
                    if (scope.data) {
                        renderGraph();
                    }
                });

                function renderGraph() {
                    var tankOverviewSeries = [];
                    /* Sort the data by Date */
                    const data = scope.data.sort((a, b) => a.calendarDate - b.calendarDate);

                    data.forEach(row => {
                        const dateInMilliseconds = new Date(row.calendarDate).getTime();
                        tankOverviewSeries.push([dateInMilliseconds, row.unitsAvailable]);

                    });

                    const legend = {
                        noColumns: 2,
                        container: element.find('#tankOverviewGraphLegend'),
                        sorted: "reverse"
                    };

                    const xaxis = {
                        mode: 'time',
                        timeBase: 'milliseconds',
                        timeformat: '%m/%Y',
                        tickLength: 0
                    };

                    function tooltipContent(label, xval, yval, flotItem) {
                        return buildTooltipContentTankOverview($filter, xval, tankOverviewSeries[flotItem.dataIndex][1]);
                    }

                    const options = {
                        legend: legend,
                        xaxis: xaxis,
                        grid: {
                            borderWidth: 0,
                            hoverable: true
                        },
                        tooltip: {
                            show: true,
                            content: tooltipContent,
                            defaultTheme: false
                        }
                    };

                    const series = [
                        {
                            label: "Available Units",
                            color: '#42a5f5',
                            data: tankOverviewSeries,
                            yaxis: 2,
                            lines: {
                                show: true,
                                fill: false
                            },
                            points: {
                                show: true,
                                fill: true,
                                fillColor: "rgba(255, 255, 255, 1)",
                                radius: 4
                            },

                        }
                    ];

                    currentSeries = series;

                    plotInstance = $.plot(element.find('#tankOverviewGraph'), series, options);
                }

                angular.element($window).on('resize', handleResize);
                document.addEventListener('visibilitychange', handleVisibilityChange);

                function handleResize() {
                    if (document.hidden) {
                        resizeWhileHidden = true;
                        return;
                    }
                    safeRedraw();
                }

                function handleVisibilityChange() {
                    if (!document.hidden) {
                        if (resizeWhileHidden) {
                            resizeWhileHidden = false;
                            if (scope.data && scope.data.length) {
                                renderGraph();
                            }
                        } else {
                            safeRedraw();
                        }
                    }
                }

                let redrawFrame;

                function safeRedraw() {
                    if (document.hidden) return;
                    cancelAnimationFrame(redrawFrame);

                    redrawFrame = requestAnimationFrame(() => {
                        if (plotInstance && currentSeries.length) {
                            const graphContainer = element.find('#tankOverviewGraph');
                            const parentWidth = graphContainer.parent().width();

                            if (parentWidth && parentWidth > 100) {
                                graphContainer.width(parentWidth);
                                plotInstance.resize();
                                plotInstance.setupGrid();
                                plotInstance.draw();
                            } else {
                                safeRedraw();
                            }
                        }
                    });
                }
                scope.$on('$destroy', function () {
                    angular.element($window).off('resize', handleResize);
                    document.removeEventListener('visibilitychange', handleVisibilityChange);
                    cancelAnimationFrame(redrawFrame);
                });
            }
        }
    }
])